import { t } from '../i18n/idioma';
import { useFechar } from '../input/useAtalhos';
import { Gump } from './Gump';

interface Props {
  name: string;
  onAccept(): void;
  onRefuse(): void;
}

/**
 * Molde do `TradeInviteGump`: Escape, clique fora e os 30 s de TTL do servidor
 * recusam pelo mesmo caminho e com o mesmo aviso.
 */
export function PartyInviteGump({ name, onAccept, onRefuse }: Props) {
  useFechar(onRefuse, { modal: true });

  return (
    <div className="modal" role="presentation" onClick={onRefuse}>
      <div role="dialog" aria-modal="true" aria-labelledby="party-invite-title" onClick={e => e.stopPropagation()}>
        <Gump
          title={t('grupo.titulo')}
          action={
            <button type="button" className="btn btn--tiny btn--ghost" onClick={onRefuse} aria-label={t('comum.fechar')}>
              ×
            </button>
          }
        >
          <div className="stack">
            <p id="party-invite-title">{t('grupo.convidaVoce', { nome: name })}</p>
            <p className="muted">{t('grupo.avisoEntrarNaCacada')}</p>
            <div className="row row--split">
              <button type="button" className="btn btn--ghost" onClick={onRefuse}>{t('comum.recusar')}</button>
              <button type="button" className="btn btn--primary" onClick={onAccept}>{t('comum.aceitar')}</button>
            </div>
          </div>
        </Gump>
      </div>
    </div>
  );
}
